export const FETCH_LOAD_LOGGED_IN_USER_PERMISSIONS_REQUEST = 'FETCH_LOAD_LOGGED_IN_USER_PERMISSIONS_REQUEST'
export const FETCH_LOAD_LOGGED_IN_USER_PERMISSIONS_SUCCESS = 'FETCH_LOAD_LOGGED_IN_USER_PERMISSIONS_SUCCESS'
export const FETCH_LOAD_LOGGED_IN_USER_PERMISSIONS_FALUIRE = 'FETCH_LOAD_LOGGED_IN_USER_PERMISSIONS_FALUIRE'
